import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ArtisanProduct from './artisanProduct';

const ArtisanProductGrid = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE}/api/products`)
      .then(response => {
        const structuredProducts = response.data.reduce((acc, item) => {
          const existingProduct = acc.find(p => p.product_id === item.product_id);
          if (existingProduct) {
            existingProduct.designs.push({
              design_id: item.design_id,
              image_data: item.image_data,
              colors: item.colors, 
            });
          } else {
            acc.push({
              product_id: item.product_id,
              name: item.name,
              description: item.description,
              price: item.price,
              designs: [{
                design_id: item.design_id,
                image_data: item.image_data,
                colors: item.colors,
              }],
            });
          }
          return acc;
        }, []);

        setProducts(structuredProducts);
      })
      .catch(error => {
        console.error('Error fetching products:', error);
      });
  }, []);

  return (
    <div className="artisan-grid">
      <div className="artisan-card-container">
        {products.length > 0 ? (
          products.map(product => <ArtisanProduct key={product.product_id} product={product} />)
        ) : (
          <p style={{ color: "#F5F5F5", textAlign: "center" }}>No products available.</p>
        )}
      </div>
    </div>
  );
};

export default ArtisanProductGrid;
